import GhostBar from "./GhostBar";

const GhostDataTableHeader = ({ title, description, rightElement }) => {
  return (
    <div className="standard-data-table-header">
      <div className="standard-data-table-header-left">
        <div className="standard-data-table-header-title">
          {title ? <GhostBar width="160px" height="24px" /> : null}
        </div>
        {description && (
          <div style={{ marginTop: "8px" }}>
            <GhostBar width="240px" height="14px" />
          </div>
        )}
      </div>
      <div className="standard-data-table-header-right">
        {rightElement || (
          <GhostBar
            width="200px"
            height="40px"
            style={{ borderRadius: "8px" }}
          />
        )}
      </div>
    </div>
  );
};

export default GhostDataTableHeader;
